<template>
<div class="uploader">
    <!-- <h1>Upload to Shotgun</h1> -->
    <el-steps class="steps" :active="activeStep" align-center finish-status="success">
        <el-step title="Upload"></el-step>
        <el-step title="Playlist"></el-step>
        <el-step title="Submit"></el-step>
    </el-steps>
    <div v-if="activeStep == 0">
        <el-upload v-if="fileEditable" class="upload-panel" ref="uploader" drag list-type="picture" action="https://jsonplaceholder.typicode.com/posts/" :auto-upload="false" :show-file-list="false" :file-list="fileList" multiple :http-request="uploadFiles">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop files here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip">File names must follow convention <span style="color: black">entity_TASK(_descriptor)_v[###].extension</span><br>you can upload multiple files at once but folders are not allowed.</div>
        </el-upload>
        <h1 v-else>Uploading...</h1>
        <ul class="upload-file-list">
            <li v-for="file in filesToUpload" :key="file.uid" style="margin: 0;">
                <file-item :file="file" v-on:file-delete="handleFileDelete" :editable="fileEditable"></file-item>
            </li>
        </ul>
        <el-button v-if="fileEditable" v-bind:type="allFilesReady? 'default': 'danger'" icon="el-icon-upload" plain style="margin-top: 12px;" @click="submit">Upload All</el-button>
        <el-button v-if="uploadDone" type='success' icon="el-icon-circle-check-outline" plain style="margin-top: 12px;" @click="submit">Continue</el-button>
    </div>
    <playlist-creator v-if="activeStep==1" :files="uploadedFiles"></playlist-creator>
    <upload-results v-if="activeStep==2" :files=uploadedFiles :playlist="playlist" :note="note"></upload-results>
</div>
</template>

<script>
import fileItem from "./fileItem";
import playlistCreator from "./playlistCreator";
import uploadResults from "./uploadResults";

export default {
  name: "AssetUploader",
  components: {
    fileItem,
    playlistCreator,
    uploadResults
  },
  data() {
    return {
      activeStep: 0,
      fileList: [],
      filesToUpload: [],
      uploadedFiles: [],
      fileEditable: true,
      playlist: null,
      note: null
    };
  },
  computed: {
    allFilesReady() {
      return this.filesToUpload.every(element => {
        return element.status == "ready";
      });
    },
    uploadDone() {
      return this.filesToUpload.length == 0 && this.uploadedFiles.length != 0;
    }
  },
  created() {
    this.$eventBus.$on("upload-success", file => {
      // first remove file from filesToUpload
      this.filesToUpload = this.filesToUpload.filter(function(e) {
        return e !== file;
      });
      // add uploaded file to uploadedFiles;
      this.uploadedFiles.push(file);
    });
    this.$eventBus.$on("submission-done", res => {
      if (res) {
        this.playlist = res.playlist;
        this.note = res.note;
      }
      this.activeStep = 2;
    });
  },
  mounted() {
    // bind filesToUpload to uploader's data.
    this.filesToUpload = this.$refs.uploader.uploadFiles;
  },
  watch: {
    // make sure uploader's uploadFiles is updated when elements removed from filesToUpload.
    filesToUpload: function(val) {
      const uploader = this.$refs.uploader;
      if (uploader) this.$refs.uploader.uploadFiles = val;
    },
    uploadDone: function(isDone) {
      if (isDone) this.activeStep = 1;
    }
  },
  methods: {
    getDefaultData() {
      return {
        activeStep: 0,
        fileList: [],
        filesToUpload: [],
        uploadedFiles: [],
        fileEditable: true,
        playlist: null,
        note: null
      };
    },
    handleFileDelete(file) {
      this.$confirm(
        `Are you sure you want to remove ${file.name} from upload list?`,
        "Removing File"
      )
        .then(() => {
          this.$notify.success(`${file.name} removed.`);
          this.filesToUpload = this.filesToUpload.filter(function(e) {
            return e !== file;
          });
        })
        .catch(() => {});
    },
    submit() {
      if (this.allFilesReady) this.$refs.uploader.submit();
      else {
        this.$alert(
          "Please rename invalid files or remove them from the upload list.",
          "Invalid File(s)"
        );
      }
    },
    uploadFiles() {
      // Emit a signal to trigger uploading on all file-items.
      this.$emit("startUpload");
      this.fileEditable = false;
    }
  }
};
</script>

<style>
.upload-panel .el-upload-dragger {
  width: 400px;
  border-width: 2px;
}
</style>

<style scoped>
.steps {
  margin-bottom: 40px;
  border: 1px solid #eee;
  padding-top: 25px;
  padding-bottom: 10px;
  border-radius: 7px;
}

.uploader {
  min-width: 400px;
}

.upload-panel {
  margin-top: 20px;
  margin-bottom: 0px;
}

.upload-file-list {
  display: flex;
  flex-direction: column;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
